import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const { pathname, search } = useLocation();
  const [token, setToken] = useState(localStorage.getItem("user"));
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    setToken(storedUser);

    if (!storedUser && !redirecting) {
      setRedirecting(true);
    }
  }, [pathname, search, redirecting]);

  if (!token && !redirecting) {
    return (
      <Navigate to="/nvm-admin" state={{ from: pathname + search }} replace />
    );
  }

  return children;
};

export default PrivateRoute;
